import React from 'react';

export interface BadgeIconProps {
  count: number;
  size?: number;
  className?: string;
}

export const EntryCountBadge = ({ count, size = 24, className = "" }: BadgeIconProps) => {

  const dynamicStyles: React.CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${size * 0.6}px`
  };

  return (
    <span
      style={dynamicStyles}
      className={`inline-flex items-center justify-center bg-palette-4 text-palette-2 rounded-full font-bold ${className}`}
    >
      {count}
    </span>
  );
};

export default EntryCountBadge;
